import { Component, HostBinding } from '@angular/core';

@Component({
    selector: 'lui-card-footer',
    template: `<ng-content></ng-content>`,
    standalone: false
})
export class CardFooterComponent {
  @HostBinding('class') className = 'lui-card-footer';
}
